<div class="flex flex-col gap-4">
	<div class="flex gap-3 lg:hidden">
		<vp-filter-sheet-button
			[indicator]="indicator()"
			[label]="'compositions.filters.title' | translate"
			[numberOfResults]="numberOfResults()"
			[openable]="true"
			data-test-id="filters-button"
			iconLeading="assets/icons/icon-filter.svg"
		>
			<ng-content />
		</vp-filter-sheet-button>
		<button
			(click)="showMap.emit()"
			class="btn btn-neutral"
			data-test-id="filters-map-button"
			type="button"
		>
			<svg-icon
				class="pointer-events-none size-4 grow-0"
				src="assets/icons/icon-map.svg"
			/>
			{{ 'compositions.filters.show-map' | translate }}
		</button>
	</div>
	<div class="flex flex-row justify-between">
		<h2 class="h4" data-test-id="filter-header-title">{{ title() }}</h2>
		<vp-dropdown
			[alignment]="dropdownAlignment()"
			[selectData]="sortOptions()"
			[value]="'global.sort-by' | translate"
			(selectedValue)="onSortChange($event)"
			data-test-id="sort-options-dropdown"
			downIcon="icon-sort"
			placeholder="global.sort-by"
			upIcon="icon-sort"
			variant="detached"
		/>
	</div>
</div>
